import {
    Alert,
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    LinearProgress,
    List,
    ListItem,
    ListItemButton,
    ListItemSecondaryAction,
    ListItemText,
    MenuItem,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import { OfferMaterialPositionTable } from "./Childs/OfferMaterialPositionTable";
import { OfferPositionTable } from "./Childs/OfferPositionTable";
import { OfferPartnerTable } from "./Childs/OfferPartnerTable";
import { IOffer } from "../../interfaces/IOffer";
import { IReasonCancellation } from "../../interfaces/IReasonCancellation";
import { IProject } from "../../interfaces/IProject";
import { ICustomer } from "../../interfaces/ICustomer";
import { ITemplate } from "../../interfaces/ITemplate";
import { IPartner } from "../../interfaces/IPartner";
import { IUnit } from "../../interfaces/IUnit";
import { IService } from "../../interfaces/IService";
import { IServiceCategory } from "../../interfaces/IServiceCategory";
import { IOfferState } from "../../interfaces/IOfferState";
import { IOfferType } from "../../interfaces/IOfferType";
import { IOfferPosition } from "../../interfaces/IOfferPosition";
import { CustomeTextField } from "../core/CustomeTextField";
import { IOfferPartner } from "../../interfaces/IOfferPartner";
import { uploadFetch } from "../../hooks/useFetch";
import { IDocument } from "../../interfaces/IDocument";
import { IOfferApplication } from "../../interfaces/IOfferApplication";
import { IOfferMaterialPosition } from "../../interfaces/IOfferMaterialPosition";
import { IMaterialCategory } from "../../interfaces/IMaterialCategory";
import { IMaterialSubcategory } from "../../interfaces/IMaterialSubcategory";
import { IMaterialDocument } from "../../interfaces/IMaterialDocument";
import { IAutomationMailWorkerEdit } from "../../interfaces/IAutomationMail";
import { useEffect, useRef, useState } from "react";
import { useUpdateOffer } from "../../hooks/data/data_offer";
import { useCreateAutomationTrigger } from "../../hooks/data/data_automation";
import { IFeedback } from "../../interfaces/IFeedback";
import { useGetOfferPackages } from "../../hooks/data/data_offerpackage";
import { IOfferPackage } from "../../interfaces/IOfferpackage";
import { IAutomationTrigger } from "../../interfaces/IAutomationTrigger";
import { OfferpackageEdit } from "../offerpackage/OfferpackageEdit";
import { CustomSnackbar } from "../core/Snackbar";
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IMaterial } from "../../interfaces/IMaterial";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

interface IProps {
    offerObject: IOffer;
    offerArray: IOffer[];
    setOfferArray: Function;

    reasonCancellationArray: IReasonCancellation[];

    projectObject: IProject;
    setProjectObject: Function;

    customerArray: ICustomer[];
    templateArray: ITemplate[];
    partnerArray: IPartner[];
    unitArray: IUnit[];
    serviceArray: IService[];
    serviceCategoryArray: IServiceCategory[];
    materialArray: IMaterial[];
    materialCategoryArray: IMaterialCategory[];
    materialSubcategoryArray: IMaterialSubcategory[];
    offerStateArray: IOfferState[];
    offerTypeArray: IOfferType[];
    materialDocumentArray: IMaterialDocument[] | undefined;
    handleSave: Function;
    handleDownload?: Function;
    automationMailWorkerEditArray: IAutomationMailWorkerEdit[];
    setAutomationMailWorkerEditArray: Function;
}

export const OfferEdit: React.FC<IProps> = ({
    offerObject,
    offerArray,
    setOfferArray,

    reasonCancellationArray,

    projectObject,
    setProjectObject,
    customerArray,
    templateArray,
    partnerArray,
    unitArray,
    serviceArray,
    serviceCategoryArray,
    materialArray,
    materialCategoryArray,
    materialSubcategoryArray,
    offerStateArray,
    offerTypeArray,
    materialDocumentArray,
    handleSave,
    handleDownload,
    automationMailWorkerEditArray,
    setAutomationMailWorkerEditArray,
}) => {
    const inputUpload = useRef<HTMLInputElement | null>(null);
    const { isPendingUpdateOffer, updateOffer } = useUpdateOffer();
    const { triggerAutomation, isPendingTriggerAutomation } = useCreateAutomationTrigger();
    const isPending = isPendingUpdateOffer || isPendingTriggerAutomation;
    //
    const [offerEdit, setOfferEdit] = useState(offerObject);
    const [offerPositionArray, setOfferPositionArray] = useState<IOfferPosition[]>(offerObject.OfferPositions);
    const [offerMaterialPositionArray, setOfferMaterialPositionArray] = useState<IOfferMaterialPosition[]>(
        offerObject.OfferMaterialPositionArray,
    );
    const [offerPartner, setOfferPartner] = useState<IOfferPartner[]>(offerObject.OfferPartners);
    const [offerApplicationArray, setOfferApplicationArray] = useState<IOfferApplication[]>(
        offerObject.OfferApplications,
    );
    const [wasSuccessfullySaved, setWasSuccessfullySaved] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenAdd, setIsOpenAdd] = useState(false);
    const [isOpenAddMaterial, setIsOpenAddMaterial] = useState(false);
    const [isOpenAssignMater, setIsOpenAssignMater] = useState(false);
    //
    const [feedback, setFeedback] = useState<IFeedback>({
        open: false,
        message: "Gespeichert!",
        severity: "success",
    } as IFeedback);

    const [value, setValue] = React.useState(0);

    const [pkgDialogOpen, setPkgDialogOpen] = useState(false);
    const { offerPackages } = useGetOfferPackages();
    const [nextNegId, setNextNegId] = useState(-1);

    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [viewPkg, setViewPkg] = useState<IOfferPackage | null>(null);

    type PendingService = { kind: "service"; id: number; quantity: number };
    type PendingMaterial = { kind: "material"; id: number; quantity: number };
    type PendingDef = {
        kind: "material_def";
        material_category: number;
        material_subcategory: number;
        quantity: number;
    };

    type PendingItem = PendingService | PendingMaterial | PendingDef;

    // 3) DupItem nur für Service/Material, nicht für material_def
    type DupService = { kind: "service"; existingIdx: number; item: PendingService };
    type DupMaterial = { kind: "material"; existingIdx: number; item: PendingMaterial };

    // 4) State mit genau diesem Discriminated Union
    const [dupItem, setDupItem] = useState<DupService | DupMaterial | null>(null);

    const [pendingItems, setPendingItems] = useState<PendingItem[]>([]);
    const [pendingDef, setPendingDef] = useState<PendingDef | null>(null);

    const idRole = localStorage.getItem("idRole");
    const isSuperuser = localStorage.getItem("is_superuser") === "true";

    const [showHistoryDialog, setShowHistoryDialog] = useState(false);
    const [allowPastChange, setAllowPastChange] = useState(false);
    const canOverride = idRole === "1" || idRole === "2" || isSuperuser;

    const handleMerge = () => {
        if (!dupItem) return;
        if (dupItem.kind === "service") {
            setOfferPositionArray((prev) => {
                const upd = [...prev];
                const { existingIdx, item } = dupItem;
                upd[existingIdx] = { ...upd[existingIdx], units: upd[existingIdx].units + item.quantity };
                return upd;
            });
        } else {
            setOfferMaterialPositionArray((prev) => {
                const upd = [...prev];
                const { existingIdx, item } = dupItem;
                upd[existingIdx] = { ...upd[existingIdx], units: upd[existingIdx].units + item.quantity };
                return upd;
            });
        }
        setDupItem(null);
    };
    const handleKeep = () => {
        if (!dupItem) return;
        const { kind, item } = dupItem;
        if (kind === "service") {
            const svc = serviceArray.find((s) => s.id === item.id)!;
            setOfferPositionArray((prev) => [
                ...prev,
                {
                    id: nextNegId,
                    Offer: offerEdit.id,
                    Partner: offerPartner[0]?.Partner ?? null,
                    Service: svc.id,
                    Unit: svc.Unit,
                    articelNumber: svc.articelNumber,
                    title: svc.title,
                    description: svc.description,
                    units: item.quantity,
                    position: prev.length + 1,
                    timeFactor: svc.timeFactor,
                    price_per_hour: 0,
                    price: 0,
                    wasChangedTimeFactor: false,
                    wasChangedPricePerHour: false,
                    wasChangedTitle: false,
                    wasChangedPrice: false,

                    checkListItems:
                        svc.checkListItems?.map((item, i) => ({
                            id: -1 * (i + 1),
                            title: item.title,
                            description: item.description,
                            isPhotoRequired: item.isPhotoRequired,
                            position: item.position,
                            //OfferPosition: newId - idx,
                            isChecked: false,
                            document_objects: [],
                        })) || [],
                },
            ]);
        } else {
            const mat = materialArray.find((m) => m.id === item.id)!;
            setOfferMaterialPositionArray((prev) => [
                ...prev,
                {
                    id: nextNegId,
                    Offer: offerEdit.id,
                    Partner: offerPartner[0]?.Partner ?? null,
                    Material: mat.id,
                    MaterialCategory: mat.MaterialCategory,
                    MaterialSubcategory: mat.MaterialSubcategory,
                    Unit: mat.Unit,
                    title: mat.title,
                    description: mat.description,
                    price_per_unit: mat.retail_price ?? 0,
                    units: item.quantity,
                    position: prev.length + 1,
                },
            ]);
        }
        setNextNegId((n) => n - 1);
        setDupItem(null);
    };
    const handleDelete = () => {
        if (!dupItem) return;
        const { kind, existingIdx, item } = dupItem;
        if (kind === "service") {
            setOfferPositionArray((prev) => {
                const filtered = prev.filter((op) => op.Service !== item.id);
                const svc = serviceArray.find((s) => s.id === item.id)!;
                return [
                    ...filtered,
                    {
                        id: nextNegId,
                        Offer: offerEdit.id,
                        Partner: offerPartner[0]?.Partner ?? null,
                        Service: svc.id,
                        Unit: svc.Unit,
                        articelNumber: svc.articelNumber,
                        title: svc.title,
                        description: svc.description,
                        units: item.quantity,
                        position: filtered.length + 1,
                        timeFactor: svc.timeFactor,
                        price_per_hour: 0,
                        price: 0,
                        wasChangedTimeFactor: false,
                        wasChangedPricePerHour: false,
                        wasChangedTitle: false,
                        wasChangedPrice: false,

                        checkListItems:
                            svc.checkListItems?.map((item, i) => ({
                                id: -1 * (i + 1),
                                title: item.title,
                                description: item.description,
                                isPhotoRequired: item.isPhotoRequired,
                                position: item.position,
                                //OfferPosition: newId - idx,
                                isChecked: false,
                                document_objects: [],
                            })) || [],
                    },
                ];
            });
        } else {
            setOfferMaterialPositionArray((prev) => {
                const filtered = prev.filter((pos) => pos.Material !== item.id);
                const mat = materialArray.find((m) => m.id === item.id)!;
                return [
                    ...filtered,
                    {
                        id: nextNegId,
                        Offer: offerEdit.id,
                        Partner: offerPartner[0]?.Partner ?? null,
                        Material: mat.id,
                        MaterialCategory: mat.MaterialCategory,
                        MaterialSubcategory: mat.MaterialSubcategory,
                        Unit: mat.Unit,
                        title: mat.title,
                        description: mat.description,
                        price_per_unit: mat.retail_price ?? 0,
                        units: item.quantity,
                        position: filtered.length + 1,
                    },
                ];
            });
        }
        setNextNegId((n) => n - 1);
        setDupItem(null);
    };
    const handleNextItem = () => {
        if (dupItem || pendingItems.length === 0) return;
        /*
        const [next, ...rest] = pendingItems;
        setPendingItems(rest);

        if (next.kind === "material_def") {
            setPendingDef(next);
            return;
        }
        */
        let initKey = -1;
        let initMaterialKey = -1;
        let initPos = 1;
        let initMaterialPos = 1;

        if (offerPositionArray.length > 0) {
            let maxPos = Math.max(...offerPositionArray.map((x) => x.position)) + 1;
            let minKey = Math.min(...offerPositionArray.map((x) => x.id)) - 1;
            if (maxPos >= initPos) {
                initPos = maxPos + 1;
            }
            if (initKey >= minKey) {
                initKey = minKey - 1;
            }
        }
        if (offerMaterialPositionArray.length > 0) {
            let maxPos = Math.max(...offerMaterialPositionArray.map((x) => x.position)) + 1;
            let minKey = Math.min(...offerMaterialPositionArray.map((x) => x.id)) - 1;
            if (maxPos >= initMaterialPos) {
                initMaterialPos = maxPos + 1;
            }
            if (initMaterialKey >= minKey) {
                initMaterialKey = minKey + 1;
            }
        }

        let addOfferPositionArray: IOfferPosition[] = [];
        let addOfferMaterialPosition: IOfferMaterialPosition[] = [];

        pendingItems.map((next, idx) => {
            if (next.kind === "material_def") {
                setPendingDef(next);
                return;
            }
            if (next.kind === "service") {
                //const idx = offerPositionArray.findIndex((op) => op.Service === next.id);
                //if (idx >= 0) {
                //    setDupItem({ kind: "service", existingIdx: idx, item: next });
                //    return;
                //}
                const svc = serviceArray.find((s) => s.id === next.id)!;
                //setOfferPositionArray((prev) => [
                //    ...prev,
                addOfferPositionArray.push({
                    id: initKey - idx,
                    Offer: offerEdit.id,
                    Partner: offerPartner[0]?.Partner ?? null,
                    Service: svc.id,
                    Unit: svc.Unit,
                    articelNumber: svc.articelNumber,
                    title: svc.title,
                    description: svc.description,
                    units: next.quantity,
                    position: initPos + idx,
                    timeFactor: svc.timeFactor,
                    price_per_hour: 0,
                    price: 0,
                    wasChangedTimeFactor: false,
                    wasChangedPricePerHour: false,
                    wasChangedTitle: false,
                    wasChangedPrice: false,

                    checkListItems:
                        svc.checkListItems?.map((item, i) => ({
                            id: -1 * (i + 1),
                            title: item.title,
                            description: item.description,
                            isPhotoRequired: item.isPhotoRequired,
                            position: item.position,
                            //OfferPosition: newId - idx,
                            isChecked: false,
                            document_objects: [],
                        })) || [],
                });

                //setNextNegId((n) => n - 1);

                // alter Material-Fall
            } else if (next.kind === "material") {
                //const idx = offerMaterialPositionArray.findIndex((mp) => mp.Material === next.id);
                //if (idx >= 0) {
                //    setDupItem({ kind: "material", existingIdx: idx, item: next });
                //    return;
                //}
                const mat = materialArray.find((m) => m.id === next.id)!;
                //setOfferMaterialPositionArray((prev) => [
                //    ...prev,
                addOfferMaterialPosition.push({
                    id: initMaterialKey - idx,
                    Offer: offerEdit.id,
                    Partner: offerPartner[0]?.Partner ?? null,
                    Material: mat.id,
                    MaterialCategory: mat.MaterialCategory,
                    MaterialSubcategory: mat.MaterialSubcategory,
                    Unit: mat.Unit,
                    title: mat.title,
                    description: mat.description,
                    price_per_unit: mat.retail_price ?? 0,
                    units: next.quantity,
                    position: initMaterialPos + idx,
                });
            }
        });

        setOfferPositionArray((prev) => [...prev, ...addOfferPositionArray]);
        setOfferMaterialPositionArray((prev) => [...prev, ...addOfferMaterialPosition]);
        // alter Service-Fall
    };
    const loadPackage = (pkg: IOfferPackage) => {
        setPendingItems([
            ...pkg.package_services.map(
                (s) => ({ kind: "service", id: s.service, quantity: s.quantity }) as PendingItem,
            ),
            ...pkg.package_materials.map(
                (m) => ({ kind: "material", id: m.material, quantity: m.quantity }) as PendingItem,
            ),
            ...pkg.package_material_defs.map(
                (d) =>
                    ({
                        kind: "material_def",
                        material_category: d.material_category,
                        material_subcategory: d.material_subcategory,
                        quantity: d.quantity,
                    }) as PendingItem,
            ),
        ]);
        setPkgDialogOpen(false);
    };
    useEffect(() => {
        if (dupItem || pendingDef) return;
        if (pendingItems.length > 0) {
            handleNextItem();
        }
    }, [pendingItems, dupItem, pendingDef]);

    useEffect(() => {
        if (offerPartner.length === 0) {
            setOfferPartner([
                {
                    id: -1,
                    Offer: offerEdit.id,
                    Partner: null,
                    selling_price_offer: 80,
                } as IOfferPartner,
            ]);
        }
    }, [offerPartner]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const updateAfterSave = (updatedOffer: IOffer) => {
        let foundOffer = offerArray.find((x) => x.id === updatedOffer.id);
        if (foundOffer === undefined) {
            setOfferArray([...offerArray, updatedOffer]);
        } else {
            setOfferArray([...offerArray.map((x) => (x.id === updatedOffer.id ? updatedOffer : x))]);
        }
        handleSave();
    };

    const createAfterSave = (res: IOffer) => {
        let updatesObject: IOffer = {
            ...res,
            OfferPositions: offerPositionArray.map((x) => {
                return { ...x, Offer: res.id };
            }),
            OfferPartners: offerPartner.map((x) => {
                return { ...x, Offer: res.id };
            }),
            OfferMaterialPositionArray: offerMaterialPositionArray.map((x) => {
                return { ...x, Offer: res.id };
            }),
        };
        uploadFetch(
            `/offer/${updatesObject.id}`,
            false,
            updatesObject,
            updateAfterSave,
            setWasSuccessfullySaved,
            () => {},
            setIsLoading,
        );
    };

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        let updatesObject: IOffer = {
            ...offerEdit,
            OfferPositions: offerPositionArray.map((x) => {
                return { ...x, Offer: offerEdit.id };
            }),
            OfferPartners: offerPartner.map((x) => {
                return { ...x, Offer: offerEdit.id };
            }),
            OfferMaterialPositionArray: offerMaterialPositionArray.map((x) => {
                return { ...x, Offer: offerEdit.id };
            }),
        };
        if (offerEdit.id < 0) {
            updatesObject.OfferPositions = [];
            updatesObject.OfferPartners = [];
            uploadFetch(
                "/offer/",
                true,
                updatesObject,
                createAfterSave,
                setWasSuccessfullySaved,
                () => {},
                setIsLoading,
            );
        } else {
            try {
                let updatededObject = await updateOffer(updatesObject);
                setFeedback({ open: true, message: "Erfolgreich gespeichert!", severity: "success" });

                if (Number(offerObject?.OfferState) < updatesObject.OfferState) {
                    let triggerAutomationObj: IAutomationTrigger = {
                        AutomationCategory: 2,
                        payload_id: offerObject.id,
                        target_state: updatesObject.OfferState,
                        current_state: Number(offerObject?.OfferState),
                    };
                    let responseAutomation = await triggerAutomation(triggerAutomationObj);
                    responseAutomation.AutomationChangeStateArray.map((autoChangeState) => {
                        if (autoChangeState.AutomationCategory === 1) {
                            setProjectObject({
                                ...projectObject,
                                ProjectState: autoChangeState.ProjectState,
                            });
                        }
                    });
                    let systemMails: IAutomationMailWorkerEdit[] = [];
                    responseAutomation.AutomationMailArray.map((autoMail) => {
                        systemMails.push({
                            ...autoMail,
                            payload_id: offerObject.id,
                            is_send: true,
                        });
                    });
                    setAutomationMailWorkerEditArray(systemMails);
                }
                updateAfterSave(updatededObject);
            } catch (error) {
                console.error(error);
                setFeedback({ open: true, message: "Es ist ein Fehler aufgeretten!", severity: "error" });
            }
        }
    };

    async function fileToBase64(file: File) {
        let result_base64 = await new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onload = (e) => resolve(fileReader.result);
            fileReader.readAsDataURL(file);
        });
        return [String(result_base64).split(",")[1], file.name];
    }

    const handleFilesUpload = async (acceptedFiles: File[]) => {
        if (acceptedFiles.length === 1) {
            let currentFile = acceptedFiles[0];
            let updateProfile: IDocument = { id: -1, file_name: "", MIMEtype: { id: 1 } };
            [updateProfile.data, updateProfile.file_name] = await fileToBase64(currentFile);

            setOfferEdit({
                ...offerEdit,
                signed_data: updateProfile.data,
            } as IOffer);
        }
    };

    const handleNormalUpload = (files: null | FileList) => {
        if (files !== null) {
            let acceptedFiles: File[] = Array.from(files);
            handleFilesUpload(acceptedFiles);
        }
    };

    const handleOpenNew = () => {
        if (value === 0) {
            setIsOpenAdd(true);
        } else {
            setIsOpenAssignMater(true);
        }
    };

    return (
        <>
            {pendingDef?.kind === "material_def" &&
                (() => {
                    const subcat = materialSubcategoryArray.find((sc) => sc.id === pendingDef.material_subcategory);
                    return (
                        <Dialog open onClose={() => setPendingDef(null)}>
                            <DialogTitle>
                                {subcat
                                    ? `Wähle Material aus Unterkategorie „${subcat.materialSubcategory}“`
                                    : "Material auswählen"}
                            </DialogTitle>
                            <DialogContent>
                                <Autocomplete<IMaterial>
                                    options={materialArray.filter(
                                        (m) => m.MaterialSubcategory === pendingDef.material_subcategory,
                                    )}
                                    getOptionLabel={(m) => `${m.title} (${m.articelNumber})`}
                                    renderInput={(params) => <TextField {...params} label="Material" />}
                                    onChange={(_, v) => {
                                        if (!v) return;
                                        setPendingItems((prev) => [
                                            ...prev,
                                            { kind: "material", id: v.id, quantity: pendingDef.quantity },
                                        ]);
                                        setPendingDef(null);
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setPendingDef(null)}>Abbrechen</Button>
                            </DialogActions>
                        </Dialog>
                    );
                })()}

            <Dialog open={!!dupItem} onClose={() => setDupItem(null)}>
                <DialogTitle>Position bereits vorhanden</DialogTitle>

                {dupItem && (
                    <DialogContent>
                        <Typography>
                            {dupItem.kind === "service"
                                ? `Leistung "${offerPositionArray[dupItem.existingIdx].title}"`
                                : `Material "${offerMaterialPositionArray[dupItem.existingIdx].title}"`}{" "}
                            ist bereits vorhanden. Wie verfahren?
                        </Typography>
                    </DialogContent>
                )}

                <DialogActions>
                    <Button onClick={handleMerge}>Zusammenführen</Button>
                    <Button onClick={handleKeep}>Beibehalten</Button>
                    <Button onClick={handleDelete}>Bestehende löschen</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={pkgDialogOpen} onClose={() => setPkgDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Angebotspaket auswählen</DialogTitle>
                <DialogContent>
                    <List>
                        {offerPackages.map((pkg) => (
                            <ListItem key={pkg.id} disablePadding>
                                <ListItemButton onClick={() => loadPackage(pkg)}>
                                    <ListItemText
                                        primary={pkg.name}
                                        secondary={`${pkg.description} — Leistungen: ${pkg.package_services.length}, Materialien: ${pkg.package_materials.length}, Kategorien: ${pkg.package_material_defs.length}`}
                                    />
                                </ListItemButton>
                                <ListItemSecondaryAction>
                                    <IconButton
                                        edge="end"
                                        onClick={() => {
                                            setViewPkg(pkg);
                                            setViewDialogOpen(true);
                                        }}
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
            </Dialog>

            <OfferpackageEdit
                open={viewDialogOpen}
                initialData={viewPkg}
                readOnly
                onClose={() => setViewDialogOpen(false)}
            />

            <CustomSnackbar feedback={feedback} setFeedback={setFeedback} />
            {isPendingTriggerAutomation && (
                <Dialog open>
                    <DialogContent>
                        Lade Automatisierungen...
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            )}
            <input
                hidden
                ref={inputUpload}
                type="file"
                accept="application/pdf"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleNormalUpload(event.target.files)}
            />

            <br />
            {isLoading && <LinearProgress sx={{ m: 2 }} />}

            <Collapse in={!wasSuccessfullySaved} sx={{ mb: 5 }}>
                <Alert severity="error">Das Angebot konnte nicht gespeichert werden!</Alert>
            </Collapse>

            <Grid container spacing={2}>
                <Grid item sm={12}>
                    <CustomeTextField
                        label="Titel"
                        attr="title"
                        type="string"
                        object={offerEdit}
                        setObject={setOfferEdit}
                        required
                        disabled={offerEdit.OfferState > 2}
                    />
                </Grid>

                <Grid item sm={6}>
                    <CustomeTextField
                        label="Angebotsart"
                        attr="OfferType"
                        type="select"
                        object={offerEdit}
                        setObject={setOfferEdit}
                        required
                        disabled={offerEdit.OfferState > 2}
                    >
                        {offerTypeArray.map((x) => (
                            <MenuItem key={`offertype-${x.id}`} value={x.id}>
                                {x.offerType}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>

                <Grid item sm={6} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CustomeTextField
                        label="Angebotsstatus"
                        attr="OfferState"
                        type="select"
                        object={offerEdit}
                        setObject={setOfferEdit}
                        required
                    >
                        {offerStateArray.map((x) => (
                            <MenuItem
                                key={`offerstate-${x.id}`}
                                value={x.id}
                                disabled={x.id < offerObject.OfferState && !(canOverride && allowPastChange)}
                            >
                                {x.offerState}
                            </MenuItem>
                        ))}
                    </CustomeTextField>

                    {canOverride && (
                        <IconButton onClick={() => setShowHistoryDialog(true)}>
                            <ManageHistoryIcon />
                        </IconButton>
                    )}
                </Grid>

                <Grid item sm={6}>
                    <Collapse in={offerEdit.OfferState === 6}>
                        <CustomeTextField
                            label="Stornogrund"
                            attr="ReasonCancellation"
                            type="select"
                            object={offerEdit}
                            setObject={setOfferEdit}
                            required={offerEdit.OfferState === 6}
                            null
                        >
                            {reasonCancellationArray.map((x) => (
                                <MenuItem key={`reasonCancellationArray-${x.id}`} value={x.id}>
                                    {x.reasonCancellation}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    </Collapse>
                </Grid>
            </Grid>

            <Collapse sx={{ mt: 5 }} in={offerEdit.OfferState > 2}>
                <Alert severity="warning">
                    Änderungen sind ab dem Status <i>Angenommen</i> nurnoch von Geschäftsführung / Assistenz
                    Geschäftsführung möglich!
                </Alert>
            </Collapse>

            <Collapse sx={{ mt: 5 }} in={offerPartner.length === 0}>
                <Alert severity="info">Bitte füngen Sie mindestens einen Partner hinzu, um fortfahren zu können</Alert>
            </Collapse>

            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Leistungsangebot" {...a11yProps(0)} />
                        <Tab label="Materialangebot" {...a11yProps(0)} />
                    </Tabs>
                </Box>

                <CustomTabPanel value={value} index={0}>
                    <>
                        <Box sx={{ mt: 5 }}>
                            <OfferPartnerTable
                                offerObject={offerObject}
                                partnerArray={partnerArray}
                                offerPartner={offerPartner}
                                setOfferPartner={setOfferPartner}
                            />
                        </Box>

                        <Box sx={{ mt: 10 }}>
                            <OfferPositionTable
                                offerObject={offerObject}
                                offerPositionArray={offerPositionArray}
                                setOfferPosition={setOfferPositionArray}
                                offerPartnerArray={offerPartner}
                                partnerArray={partnerArray}
                                serviceArray={serviceArray}
                                serviceCategoryArray={serviceCategoryArray}
                                isOpenAdd={isOpenAdd}
                                setIsOpenAdd={setIsOpenAdd}
                                unitArray={unitArray}
                            />
                        </Box>
                    </>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                    <OfferMaterialPositionTable
                        offerObject={offerObject}
                        offerMaterialPositionArray={offerMaterialPositionArray}
                        setOfferMaterialPositionArray={setOfferMaterialPositionArray}
                        unitArray={unitArray}
                        materialArray={materialArray}
                        materialCategoryArray={materialCategoryArray}
                        materialSubcategoryArray={materialSubcategoryArray}
                        isOpenAddMaterial={isOpenAddMaterial}
                        setIsOpenAddMaterial={setIsOpenAddMaterial}
                        isOpenAssignMaterial={isOpenAssignMater}
                        setIsOpenAssignMaterial={setIsOpenAssignMater}
                        materialDocumentArray={materialDocumentArray}
                    />
                </CustomTabPanel>

                <Box
                    sx={{
                        position: "sticky",
                        bottom: 30,
                        right: 0,
                        zIndex: 100,
                        p: 2,
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-end",
                        gap: 2,
                    }}
                >
                    {/* Angebotspaket immer als erster */}
                    <Button
                        variant="outlined"
                        sx={{ width: 150 }}
                        disabled={offerEdit.OfferState > 2}
                        onClick={() => setPkgDialogOpen(true)}
                    >
                        Angebotspaket
                    </Button>

                    {/* Leere Position nur im Material-Tab */}
                    {value === 1 && (
                        <Button
                            variant="contained"
                            sx={{ width: 150 }}
                            disabled={offerPartner.length === 0 || offerObject.OfferState > 2}
                            onClick={() => setIsOpenAddMaterial(true)}
                        >
                            Leere Position
                        </Button>
                    )}

                    {/* Haupt-Button */}
                    <Button
                        variant="contained"
                        sx={{ width: 150 }}
                        disabled={offerPartner.length === 0 || offerObject.OfferState > 2}
                        onClick={handleOpenNew}
                    >
                        {value === 0 ? "Neue Position" : "Material zuweisen"}
                    </Button>

                    {/* Speichern-Button */}
                    <Button variant="contained" sx={{ minWidth: 100 }} disabled={isPending} onClick={handleSubmit}>
                        {isPending ? (
                            <Box display="flex" alignItems="center" gap={1}>
                                <span>Speichern</span>
                                <CircularProgress size={20} />
                            </Box>
                        ) : (
                            "Speichern"
                        )}
                    </Button>
                </Box>
            </Box>

            <Dialog open={showHistoryDialog} onClose={() => setShowHistoryDialog(false)}>
                <DialogTitle>Warnung</DialogTitle>
                <DialogContent>
                    Durch Zurücksetzen in einen früheren Status können bereits ausgelöste Automatisierungen (z. B.
                    automatisch versendete E-Mails) erneut ausgelöst werden. Bitte stellen Sie sicher, dass Sie diese
                    Aktion wirklich durchführen möchten.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowHistoryDialog(false)}>Abbrechen</Button>
                    <Button
                        onClick={() => {
                            setAllowPastChange(true);
                            setShowHistoryDialog(false);
                        }}
                    >
                        Akzeptieren
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
